import Success from './Success'
import Error from './Error'
import Registry from './Registry'
import InfoWarning from './InfoWarning/InfoWarning'
import Warning from './Warning'

export {
	Success,
	Error,
	Registry,
	InfoWarning,
	Warning
}



// WEBPACK FOOTER //
// ./src/client/website/components/Messages/index.js